// removed by extract-text-webpack-plugin
module.exports = {"label":"_3UBYw8K3uQocy2fY"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/CheckBox/Label.pcss
// module id = 468
// module chunks = 1